<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  import Layout from "@/layouts/main";
  import Navbar from "@/components/navbar";
  import { EventBus } from "@/event-bus";
  import { VueDaumPostcode } from "vue-daum-postcode/dist";
  
  export default {
    components: {
      Layout,
      Navbar,
      VueDaumPostcode
    },
    data() {
      return {
        appConfig: appConfig,
        login: {
          idx: 0,
          level: 0,
          nick: "",
          isLogin: false,
        },
        editPage: false,
        textData: {
          topText1: "",
          topText2: "",
          otherText1: "",
          otherText2: "",
          policy1: "",
          policy2: "",
        },
        baseInfo: {},
        infoAgree1: "<b>수집 및 이용목적</b> : 정회원 or 후원회원 가입 및 관리, 후원금 수납 및 관리</br>" +
          "<b>수집항목</b> : 성명, 생년월일(또는 주민등록번호), 휴대폰번호, 이메일, 주소, 은행명, 예금주명, 계좌번호</br>" +
          "<b>보유 및 이용기간</b> : 수집/이용 동의일부터 후원 종료일(해지일)까지</br>" +
          "<b>신청자는 개인정보 및 고유식별장요 수집 및 이용을 거부할 권리가 있으며, 국세청 홈택스 기부영수증발급 신청이 거부 될 수도 있습니다.</b>",
        infoAgree2: "<b>개인정보를 제공받는 자</b>: 금융결제원, ㈜휴먼소프트웨어 (humansoftware.co.kr), 금융기관(하단 신청가능은행 참조), 통신사(SKT, KT LGU+, CJ헬로비전)등</br>" +
          "<b>개인정보를 제공받는 자의 이용 목적</b>: ㈜휴먼소프트웨어 후원자 및 결제 데이터관리 및 기부금영수증 발급관리</br>" +
          "<b>제공하는 개인정보의 항목</b>: 성명, 생년월일(또는 주민등록번호), 휴대폰번호, 은행명, 예금주명, 계좌번호</br>" +
          "<b>개인정보를 제공받는자의 개인정보 보유 및 이용기간</b>: 동의일로부터 자동이체의 종료일(해지일)까지. 단, 관계 법령에 의거 일정기간 동안 보관</br>" +
          "<b>신청자는 개인정보 및 고유식별 정보 수집 및 이용을 거부할 권리가 있으며, 거부 시 자동이체 신청이 처리되지 않으며, 기부금영수증 발급 신청이 거부될 수 있습니다.</b>",
        signUpForm: {
          name: "",
          email: "",
          phone: "",
          bank: "",
          accountNumber: "",
          accountHolder: "",
          donationAmount: 0, // 계산용으로만 사용
          customAmount: 0, // 실제 금액 처리부분 (후원금액 선택시 실제 금액으로 변경)
          address: "",
          address2: "",
          birthday: "",
          ssn: "",
          signatureImage: "",
          memberType: "정회원",
          receiptAgree: "발급함",
          referral: "",
          joinReason: "",
          selectDay: "",
        },
        infoAgree1Agree: false,
        infoAgree2Agree: false,
        // 싸인 시작
        signatureOptions: {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)' // 검정색
        },
        isSignatureEmpty: true,
        // 싸인 끝
      }
    },
    computed: {
    },
    metaInfo() {
      return {
        title: '후원 신청하기 | 대구여성인권센터',
        meta: [
          {
            name: 'description',
            content: '대구여성인권센터와 함께해주세요. 성착취 없는 세상을 희망하고 상상하고 행동하는 일, 여러분의 후원은 반성매매운동의 변화를 가능하게 하는 힘입니다.'
          },
          {
            property: 'og:title',
            content: '후원 신청하기 | 대구여성인권센터'
          },
          {
            property: 'og:description',
            content: '대구여성인권센터와 함께해주세요. 성착취 없는 세상을 희망하고 상상하고 행동하는 일, 여러분의 후원은 반성매매운동의 변화를 가능하게 하는 힘입니다.'
          },
          {
            property: 'og:url',
            content: window.location.href
          },
          {
            name: 'twitter:title',
            content: '후원 신청하기 | 대구여성인권센터'
          },
          {
            name: 'twitter:description',
            content: '대구여성인권센터와 함께해주세요. 성착취 없는 세상을 희망하고 상상하고 행동하는 일, 여러분의 후원은 반성매매운동의 변화를 가능하게 하는 힘입니다.'
          }
        ]
      }
    },
    mounted() {
      // 관리자 텍스트설정 가져오기
      this.jy_support_admin_get();
      // 서명 패드에 이벤트 리스너 추가
      this.$nextTick(() => {
        if (this.$refs.sign_up_form_signature && this.$refs.sign_up_form_signature.$el) {
          const canvas = this.$refs.sign_up_form_signature.$el.querySelector('canvas');
          if (canvas) {
            // 마우스/터치 이벤트로 서명 시작 감지
            const handleStart = () => {
              this.isSignatureEmpty = false;
            };
            canvas.addEventListener('mousedown', handleStart);
            canvas.addEventListener('touchstart', handleStart);
            
            // 서명 종료 후 비어있는지 확인
            const handleEnd = () => {
              setTimeout(() => {
                if (this.$refs.sign_up_form_signature) {
                  try {
                    const { isEmpty } = this.$refs.sign_up_form_signature.saveSignature();
                    this.isSignatureEmpty = isEmpty;
                  } catch (e) {
                    // 에러 무시
                  }
                }
              }, 100);
            };
            canvas.addEventListener('mouseup', handleEnd);
            canvas.addEventListener('touchend', handleEnd);
          }
        }
      });
    },
    created() {
      this.first()
    },
    methods: {
      // 홈페이지 기본정보
      first() {
        // 로그인 사용자 정보
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
        }
        this.baseInfo = this.$store.getters.getWebSiteInfoBase
      },
      // 전화번호 포맷팅 함수
      formatPhoneNumber(event) {
        let value = event.target.value.replace(/[^0-9]/g, ''); // 숫자만 추출
        
        // 11자리 제한 (010-XXXX-XXXX)
        if (value.length > 11) {
          value = value.substring(0, 11);
        }
        
        // 하이픈 추가
        if (value.length > 3 && value.length <= 7) {
          value = value.substring(0, 3) + '-' + value.substring(3);
        } else if (value.length > 7) {
          value = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7);
        }
        
        this.signUpForm.phone = value;
        event.target.value = value;
      },
      // 생년월일 포맷팅 함수
      formatBirthday(event) {
        let value = event.target.value.replace(/[^0-9]/g, ''); // 숫자만 추출
        if (value.length > 8) {
          value = value.substring(0, 8);
        }
        if (value.length > 4) {
          value = value.substring(0, 4) + '-' + value.substring(4);
        }
        if (value.length > 7) {
          value = value.substring(0, 7) + '-' + value.substring(7);
        }
        this.signUpForm.birthday = value;
        event.target.value = value;
      },
      // 주민번호 포맷팅 함수
      formatSSN(event) {
        let value = event.target.value.replace(/[^0-9]/g, ''); // 숫자만 추출
        
        // 13자리 제한 (000000-0000000)
        if (value.length > 13) {
          value = value.substring(0, 13);
        }
        
        // 하이픈 추가
        if (value.length > 6) {
          value = value.substring(0, 6) + '-' + value.substring(6);
        }
        
        this.signUpForm.ssn = value;
        event.target.value = value;
      },
      // 주소 찾기
      openAddressWindow() {
        this.$bvModal.show('addressSearchModal')
      },
      // 주소 검색 결과 반환
      addressComplete:function(result) {
        if(result.userSelectedType === 'R'){  // 도로명 주소 선택
          this.signUpForm.address = result.roadAddress;
        } else {  // 지번 주소 선택
          this.signUpForm.address = result.jibunAddress;
        }
        this.$bvModal.hide('addressSearchModal')
      },
      calculateDonationAmount() {
        this.signUpForm.customAmount = this.signUpForm.donationAmount;
      },
      // 서명 이미지로 변환 함수
      signatureSave() {
        const { isEmpty, data } = this.$refs.sign_up_form_signature.saveSignature();
        if (isEmpty) {
          return false;
        }
        // data는 base64 인코딩된 이미지 데이터입니다
        this.signUpForm.signatureImage = data;
        return true;
      },
      signatureClear() {
        this.$refs.sign_up_form_signature.clearSignature();
        this.signUpForm.signatureImage = "";
        this.isSignatureEmpty = true;
      },
      onSignatureBegin() {
        this.isSignatureEmpty = false;
      },
      onSignatureEnd() {
        // 서명이 끝났을 때 비어있는지 확인
        if (this.$refs.sign_up_form_signature) {
          const { isEmpty } = this.$refs.sign_up_form_signature.saveSignature();
          this.isSignatureEmpty = isEmpty;
        }
      },
      // 테스트용
      handleSubmit(event) {
        // 서명 저장
        if (!this.signatureSave()) {
          event.preventDefault();
          alert('서명을 입력해주세요.');
          return false;
        }
        
        // 여기에 실제 폼 제출 로직 추가
        console.log('신청서 제출:', this.signUpForm);
        // axios.post('/api/submit', this.signUpForm) 등으로 서버에 전송
        
        // 임시로 alert만 표시
        alert('신청서가 제출되었습니다.');
      },
      saveSignature() {
        const { isEmpty, data } = this.$refs.sign_up_form_signature.saveSignature();
        console.log(isEmpty);
        console.log(data);
      },
      // 기다려주세요 loading 처리
      loadingBar(val) {
        if (val === true) {
          document.getElementById("preloader").style.display = "block";
          document.getElementById("status").style.display = "block";
        } else {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }
      },
      async submitSignUpForm() {
        //console.log('신청서 제출:', this.signUpForm);
        //alert('필수항목 넣었는지 확인하는거 처리하고, 백엔드로 데이터 넣는거 작업 해야됨')
        // 서명 이미지화로 변환
        this.signatureSave();
        if (this.validateFormCheck()) { // 유효성 검사 통과하면 신청서 제출
          try {
            this.loadingBar(true)
            await axios({
              method: 'POST',
              url: appConfig.fastapi + '/auth/c_support_apply',
              data: {
                "name": this.signUpForm.name,
                "phone": this.signUpForm.phone,
                "address": this.signUpForm.address,
                "address2": this.signUpForm.address2,
                "bank": this.signUpForm.bank,
                "accountNumber": this.signUpForm.accountNumber,
                "accountHolder": this.signUpForm.accountHolder,
                "customAmount": this.signUpForm.customAmount,
                "selectDay": this.signUpForm.selectDay,
                "receiptAgree": this.signUpForm.receiptAgree,
                "ssn": this.signUpForm.ssn,
                "birthday": this.signUpForm.birthday,
                "signatureImage": this.signUpForm.signatureImage,
                "joinReason": this.signUpForm.joinReason,
                "referral": this.signUpForm.referral,
                "memberType": this.signUpForm.memberType,
                "email": this.signUpForm.email,
              },
            })
            .then((res) => {
              if (res.data.type == 'success') {
                this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: "신청서가 제출되었습니다." })
              } else {
                this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: res.data.error })
              }
            })
            .catch((error) => {
              console.log(error)
              this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: '요청 중 에러 발생 관리자에게 문의' })
            })
          } catch (error) {
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의' })
          } finally {
            this.loadingBar(false)
          }
        }
      },
      // 유효성 검사 (필수항목 다 체크했는지)
      validateFormCheck() {
        if (!this.signUpForm.name) {
          alert('신청인 성명을 입력해주세요.');
          // 신청인 폼으로 이동
          this.$refs.sign_up_form_name.focus();
          return false;
        } else if (!this.signUpForm.phone) {
          alert('휴대폰번호를 입력해주세요.');
          this.$refs.sign_up_form_phone.focus();
          return false;
        } else if (!this.signUpForm.customAmount) {
          alert('후원금액을 선택해주세요');
          this.$refs.sign_up_form_donation_amount_1.focus();
          return false;
        } else if (!this.signUpForm.selectDay) {
          alert('자동이체 출금일을 선택해주세요');
          this.$refs.sign_up_form_select_day_1.focus();
          return false;
        } else if (this.signUpForm.receiptAgree == '발급함' && !this.signUpForm.ssn) {
          alert('영수증 발급 동의 하셨으면 주민등록번호를 입력해주세요');
          this.$refs.sign_up_form_ssn.focus();
          return false;
        } else if (!this.signUpForm.signatureImage) {
          alert('서명을 입력해주세요.');
          this.$refs.sign_up_form_signature_canvas.focus();
          return false;
        } else {
          return true;
        }
      },
      textDataEdit() {
        this.editPage = true
        // textData.policy1과 textData.policy2에서 <br />을 줄바꿈으로 변경
        this.textData.policy1 = this.textData.policy1.replace(/<br \/>/gi, '\n');
        this.textData.policy2 = this.textData.policy2.replace(/<br \/>/gi, '\n');
      },
      textDataEditCancelButton() {
        this.editPage = false
      },
      // 관리자 편집 저장
      textDataSaveButton() {
        if (this.textData.topText1 && this.textData.topText2 && this.textData.otherText1 && this.textData.otherText2 && this.textData.policy1 && this.textData.policy2) {
          // textData.policy1과 textData.policy2에서 줄바꿈을 <br />로 변경
          this.textData.policy1 = this.textData.policy1.replace(/\n/gi, '<br />');
          this.textData.policy2 = this.textData.policy2.replace(/\n/gi, '<br />');
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/board/jy_support_admin_edit_save',
            data: {
              textData: this.textData,
              work: "sign_up_save",
            },
          })
          .then((res) => {
            console.log(res);
            if (res.data.status == 'success') {
              this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: "편집 내용이 저장되었습니다." })
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: res.data.text })
            }
          })
          .catch((error) => {
            console.log(error);
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의' })
          })
          .finally(() => {
            this.editPage = false;
          });
        } else {
          this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: "모든 항목을 입력해주세요" })
        }
      },
      // 관리자 텍스트설정 가져오기
      jy_support_admin_get() {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_support_admin_get',
          data: {
            "work": "sign_up",
          },
        })
        .then((res) => {
          if (res.data.status == 'success') {
            this.textData = res.data.textData;
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: res.data.text })
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의' })
        })
      }
    },
  }
  </script>
  
  <template>
    <Layout>
      <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
      <Navbar :nav-light="true" />

      <!-- 주소 검색 모달 -->
      <b-modal
        id="addressSearchModal"
        centered
        title="배송지 주소 찾기"
        title-class="font-size-18"
        hide-footer
      >
        <VueDaumPostcode @complete="addressComplete"></VueDaumPostcode>
      </b-modal>
  
      <section class="bg-half-2 navwave d-table w-100">
        <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
        <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
        <div class="bread-overlay-2 opacity-5"></div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <div class="title text-white title-dark">
                  <h3>후원</h3>
                  <h4>센터와 함께해주세요</h4>
                </div>
                <div class="page-next">
                  <nav aria-label="breadcrumb" class="d-inline-block">
                    <ul class="breadcrumb bg-white rounded shadow mb-0">
                      <li class="breadcrumb-item">
                        <router-link to="/">홈</router-link>
                      </li>
                      <li class="breadcrumb-item active" aria-current="page">후원</li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 둥글게 처리 -->
      <div class="position-relative">
        <div class="shape overflow-hidden text-white">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
          </svg>
        </div>
      </div>
  
      <section class="mb-0 py-5">
        <div class="container">

          <!-- 관리자라면 -->
          <div v-if="login.level > 97 && !editPage" class="mb-4">
            <b-button @click="textDataEdit()" class="btn btn-block btn-md btn-soft-blue">
              <i class="mdi mdi-book-edit mr-1"></i>관리자 편집하기
            </b-button>
          </div>
          <!-- 관리자 편집 페이지 -->
          <div v-if="login.level > 97 && editPage" class="mb-4">
            <b-button @click="textDataEditCancelButton()" class="btn btn-block btn-md btn-primary">
              <i class="mdi mdi-close mr-1"></i>편집 닫기
            </b-button>
          </div>

          <!-- 관리자 설정 미리 세팅 -->
          <div v-if="editPage" class="row align-items-center">
            <div class="col-lg-12 col-md-6 mt-sm-0 pt-sm-0">
              <div class="card mb-4 border-primary">
                <div class="card-header">
                  <h4 class="title mb-4">관리자 텍스트 편집</h4>
                  <div class="font-size-13 text-muted mb-4">*후원계좌 설정은 관리자페이지 > 최고관리 기능 > 기본설정에서 가능합니다.</div>
                  <div class="mb-4">
                    <b-button @click="textDataSaveButton()" class="btn btn-square btn-block btn-md btn-blue">저장하기</b-button>
                  </div>
                  
                </div>
                <div class="card-body">
                  <b-form-text class="h6 text-muted mt-4 mb-0">* 상단에 후원 신청서 작성 설명글을 입력해주세요</b-form-text>
                  <b-form-input v-model="textData.topText1" type="text" class="form-control input-square font-size-14 font-weight-bold" placeholder="내용을 입력해주세요" />
                  <b-form-input v-model="textData.topText2" type="text" class="form-control input-square font-size-14 font-weight-bold" placeholder="내용을 입력해주세요" />
                  <b-form-text class="h6 text-muted mt-4 mb-0">* 기부금 영수증 설명글을 입력해주세요</b-form-text>
                  <b-form-input v-model="textData.otherText1" type="text" class="form-control input-square font-size-14 font-weight-bold" placeholder="내용을 입력해주세요" />
                  <b-form-text class="h6 text-muted mt-4 mb-0">* 주민등록번호 설명글을 입력해주세요</b-form-text>
                  <b-form-input v-model="textData.otherText2" type="text" class="form-control input-square font-size-14 font-weight-bold " placeholder="내용을 입력해주세요" />
                  <b-form-text class="h6 text-muted mt-4 mb-0">*개인정보 수집 및 이용 동의 편집할 내용을 입력해주세요</b-form-text>
                  <b-form-textarea v-model="textData.policy1" rows="6" maxlength="1000" class="form-control input-square font-size-14 font-weight-bold" placeholder="내용을 입력해주세요" />
                  <b-form-text class="h6 text-muted mt-4 mb-0">* 개인정보 제3자 제공에 대해 동의 편집할 내용을 입력해주세요</b-form-text>
                  <b-form-textarea v-model="textData.policy2" rows="6" maxlength="1000" class="form-control input-square font-size-14 font-weight-bold" placeholder="내용을 입력해주세요" />
                </div>
              </div>
              
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-lg-8 col-md-6 mt-sm-0 pt-sm-0">
              <div class="section-title ml-lg-3">
                <span class="badge badge-pill badge-primary mb-2">
                  <i class="mdi mdi-flower-tulip-outline h3"></i>
                </span>
                <h4 class="title mb-4">후원 신청서 작성</h4>
                <p class="text-muted mb-4">
                  <span v-if="textData.topText1">{{ textData.topText1 }}</span></br>
                  <span v-if="textData.topText2">{{ textData.topText2 }}</span></br>
                </p>
                <p class="bg-soft-primary text-primary p-3 rounded font-size-13 font-weight-bold mb-4">
                  <span class="text-bold">
                    <i class="mdi mdi-bank"></i> 후원계좌</span> <br>
                    <span class="text-bold">예금주</span>: (사)대구여성인권센터 <br>
                    <span class="text-bold">계좌번호</span>: IM뱅크 (구 대구은행) 009-12-005221
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <!--<img src="images/_decen/cat.png" alt="" class="img-fluid mx-auto sign-up-img">-->
            </div>
          </div>
        </div>

        <!-- 폼 시작 -->
        <div class="container mt-60 pb-md-5 mb-md-5">
          
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="section-title mb-4 pb-2">
                <div class="card bg-light">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_member_type_1" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            회원유형<i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <div class="custom-control custom-radio custom-control-inline mb-3">
                              <div class="form-group mb-0">
                                <input
                                  type="radio"
                                  id="sign_up_form_member_type_1"
                                  name="sign_up_form_member_type"
                                  v-model="signUpForm.memberType"
                                  value="정회원"
                                  class="custom-control-input"
                                />
                                <label class="custom-control-label" for="sign_up_form_member_type_1">
                                  정회원 </br>
                                  <span class="text-muted">
                                    (총회 의결권 및 선거권 다양한 활동 및 프로그램 참여 월 1만원 이상 후원)
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                              <div class="form-group mb-0">
                                <input
                                  type="radio"
                                  id="sign_up_form_member_type_2"
                                  name="sign_up_form_member_type"
                                  v-model="signUpForm.memberType"
                                  value="후원회원"
                                  class="custom-control-input"
                                />
                                <label class="custom-control-label" for="sign_up_form_member_type_2">
                                  후원회원 </br>
                                  <span class="text-muted">
                                    (다양한 활동 및 프로그램 참여 약정후원)
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_name" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            신청인 <i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_name"
                              name="sign_up_form_name"
                              id="sign_up_form_name"
                              type="text"
                              v-model="signUpForm.name"
                              class="form-control font-weight-bold"
                              required
                              placeholder="성명을 적어주세요"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_phone" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            휴대폰번호 <i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_phone"
                              name="sign_up_form_phone"
                              id="sign_up_form_phone"
                              type="tel"
                              v-model="signUpForm.phone"
                              @input="formatPhoneNumber"
                              autocomplete="off"
                              class="form-control font-weight-bold"
                              required
                              placeholder="010-0000-0000"
                              maxlength="13"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label for="sign_up_form_address" class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            주소
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_address"
                              @click="openAddressWindow()"
                              v-model="signUpForm.address"
                              name="sign_up_form_address"
                              id="sign_up_form_address"
                              type="text"
                              class="form-control font-weight-bold mb-2"
                              placeholder="주소를 적어주세요"
                            />
                            <input
                              ref="sign_up_form_address2"
                              v-model="signUpForm.address2"
                              name="sign_up_form_address2"
                              id="sign_up_form_address2"
                              type="text"
                              class="form-control font-weight-bold"
                              placeholder="상세 주소를 적어주세요"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_email" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            이메일
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_email"
                              name="sign_up_form_email"
                              id="sign_up_form_email"
                              type="email"
                              v-model="signUpForm.email"
                              class="form-control font-weight-bold"
                              placeholder="이메일주소를 적어주세요"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_bank" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            은행선택
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <select
                              ref="sign_up_form_bank"
                              name="sign_up_form_bank"
                              id="sign_up_form_bank"
                              v-model="signUpForm.bank"
                              type="select"
                              class="form-control font-weight-bold"
                              required
                            >
                              <option value="" selected="">(선택)</option>
                              <option value="IM뱅크">IM뱅크 (구) 대구은행</option>
                              <option value="카카오뱅크">카카오뱅크</option>
                              <option value="국민은행">국민은행</option>
                              <option value="기업은행">기업은행</option>
                              <option value="신한은행">신한은행</option>
                              <option value="산업은행">산업은행</option>
                              <option value="농협은행">농협은행</option>
                              <option value="우리은행">우리은행</option>
                              <option value="하나은행">하나은행</option>
                              <option value="경남은행">경남은행</option>
                              <option value="부산은행">부산은행</option>
                              <option value="광주은행">광주은행</option>
                              <option value="저축은행">저축은행</option>
                              <option value="수협">수협</option>
                              <option value="우체국">우체국</option>
                              <option value="제주은행">제주은행</option>
                              <option value="토스뱅크">토스뱅크</option>
                              <option value="한국씨티은행">한국씨티은행</option>
                              <option value="SC제일은행">SC제일은행</option>
                              <option value="새마을금고">새마을금고</option>
                              <option value="신협중앙회">신협중앙회</option>
                              <option value="전북은행">전북은행</option>
                              <option value="케이뱅크">케이뱅크</option>
                              <option value="기타 (계좌번호 입력란에 은행명을 함께 입력해주세요)">기타(계좌번호와 함께 입력해주세요)</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_account_number" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            계좌번호
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_account_number"
                              v-model="signUpForm.accountNumber"
                              name="sign_up_form_account_number"
                              id="sign_up_form_account_number"
                              type="text"
                              autocomplete="off"
                              class="form-control font-weight-bold"
                              required
                              placeholder="계좌번호를 적어주세요"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_account_holder" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            예금주명
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_account_holder"
                              v-model="signUpForm.accountHolder"
                              name="sign_up_form_account_holder"
                              id="sign_up_form_account_holder"
                              type="text"
                              class="form-control font-weight-bold"
                              required
                              placeholder="예금주명을 적어주세요"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label for="sign_up_form_account_number" class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            후원금액 <i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <div class="component-wrapper">
                              <div class="p-2">
                                <div ref="sign_up_form_custom_amount" class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_1"
                                      type="radio"
                                      id="sign_up_form_donation_amount_1"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      @change="calculateDonationAmount"
                                      value="10000"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_1">
                                      1만원 
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_2"
                                      type="radio"
                                      id="sign_up_form_donation_amount_2"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      @change="calculateDonationAmount"
                                      value="20000"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_2">
                                      2만원 
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_3"
                                      type="radio"
                                      id="sign_up_form_donation_amount_3"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      @change="calculateDonationAmount"
                                      value="30000"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_3">
                                      3만원 
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_4"
                                      type="radio"
                                      id="sign_up_form_donation_amount_4"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      @change="calculateDonationAmount"
                                      value="40000"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_4">
                                      4만원 
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_5"
                                      type="radio"
                                      id="sign_up_form_donation_amount_5"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      @change="calculateDonationAmount"
                                      value="50000"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_5">
                                      5만원 
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_6"
                                      type="radio"
                                      id="sign_up_form_donation_amount_6"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      @change="calculateDonationAmount"
                                      value="100000"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_6">
                                      10만원 
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_donation_amount_7"
                                      type="radio"
                                      id="sign_up_form_donation_amount_7"
                                      name="sign_up_form_donation_amount"
                                      v-model="signUpForm.donationAmount"
                                      value="기타"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_donation_amount_7">
                                      기타
                                    </label>
                                  </div>
                                </div>
                                <div v-if="signUpForm.donationAmount === '기타'" class="custom-control-inline ml-3">
                                  <input
                                    type="number"
                                    v-model="signUpForm.customAmount"
                                    class="form-control"
                                    placeholder="금액 입력"
                                    min="0"
                                    style="width: 150px; display: inline-block;"
                                  />
                                  <span class="ml-2">원</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label for="sign_up_form_select_day" class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            자동이체 출금일 <i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <div class="component-wrapper">
                              <div class="p-2">
                                <div ref="sign_up_form_select_day" class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_select_day_1"
                                      type="radio"
                                      id="sign_up_form_select_day_1"
                                      name="sign_up_form_select_day"
                                      v-model="signUpForm.selectDay"
                                      value="5"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_select_day_1">
                                      매월 5일
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_select_day_2"
                                      type="radio"
                                      id="sign_up_form_select_day_2"
                                      name="sign_up_form_select_day"
                                      v-model="signUpForm.selectDay"
                                      value="15"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_select_day_2">
                                      매월 15일
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_select_day_3"
                                      type="radio"
                                      id="sign_up_form_select_day_3"
                                      name="sign_up_form_select_day"
                                      v-model="signUpForm.selectDay"
                                      value="25"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_select_day_3">
                                      매월 25일
                                    </label>
                                  </div>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label for="sign_up_form_receipt_agree" class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            기부금 영수증<i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <div class="component-wrapper">
                              <div class="p-2">
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_receipt_agree_1"
                                      type="radio"
                                      id="sign_up_form_receipt_agree_1"
                                      name="sign_up_form_receipt_agree"
                                      v-model="signUpForm.receiptAgree"
                                      value="발급함"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_receipt_agree_1">
                                      발급합니다
                                    </label>
                                  </div>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <div class="form-group mb-0">
                                    <input
                                      ref="sign_up_form_receipt_agree_2"
                                      type="radio"
                                      id="sign_up_form_receipt_agree_2"
                                      name="sign_up_form_receipt_agree"
                                      v-model="signUpForm.receiptAgree"
                                      value="발급안함"
                                      class="custom-control-input"
                                    />
                                    <label class="custom-control-label" for="sign_up_form_receipt_agree_2">
                                      발급하지 않습니다
                                      <span class="text-muted">
                                        (원하지 않으시면 발급하지 않습니다)
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div v-if="textData.otherText1" class="p-1 rounded bg-soft-primary form-text text-danger font-size-12 font-weight-bold mt-1 d-block">
                                {{ textData.otherText1 }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="signUpForm.receiptAgree === '발급함'" class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label for="sign_up_form_ssn" class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            주민등록번호 <i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_ssn"
                              v-model="signUpForm.ssn"
                              name="sign_up_form_ssn"
                              id="sign_up_form_ssn"
                              type="text"
                              @input="formatSSN"
                              autocomplete="on"
                              class="form-control font-weight-bold"
                              placeholder="000000-0000000"
                              maxlength="14"
                            />
                            <span v-if="textData.otherText2" class="p-1 rounded bg-soft-primary form-text text-danger font-size-12 font-weight-bold mt-1 d-block">
                              {{ textData.otherText2 }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-if="signUpForm.receiptAgree === '발급안함'" class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_birthday" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            생년월일 입력
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_birthday"
                              v-model="signUpForm.birthday"
                              name="sign_up_form_birthday"
                              id="sign_up_form_birthday"
                              type="text"
                              class="form-control font-weight-bold"
                              placeholder="ex) 1980-01-01"
                              maxlength="14"
                              @input="formatBirthday"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <label for="sign_up_form_referral" class="text-muted mb-0 mb-md-0" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            추천인 
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <input
                              ref="sign_up_form_referral"
                              v-model="signUpForm.referral"
                              name="sign_up_form_referral"
                              id="sign_up_form_referral"
                              type="text"
                              class="form-control font-weight-bold"
                              placeholder="추천인이 있다면 적어주세요"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label for="sign_up_form_join_reason" class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            가입동기
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <textarea
                              ref="sign_up_form_join_reason"
                              v-model="signUpForm.joinReason"
                              name="sign_up_form_join_reason"
                              id="sign_up_form_join_reason"
                              class="form-control font-weight-bold"
                              placeholder="가입동기나 대센에 하고싶은 말씀을 적어주세요"
                              rows="3"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group d-flex flex-column flex-md-row align-items-start">
                          <label class="text-muted mb-0 mb-md-0 pt-md-2" style="width: auto; flex-shrink: 0; min-width: 130px;">
                            서명 그리기 <i class="mdi mdi-asterisk text-danger"></i>
                          </label>
                          <div style="flex: 1; width: 100%;">
                            <div class="card">
                              <div ref="sign_up_form_signature_canvas" class="card-body p-0 position-relative">
                                <VueSignaturePad
                                  ref="sign_up_form_signature"
                                  :options="signatureOptions"
                                  width="100%"
                                  height="300px"
                                  :penColor="signatureOptions.penColor"
                                  :backgroundColor="signatureOptions.backgroundColor"
                                  :penWidth="5"
                                  @begin="onSignatureBegin"
                                  @end="onSignatureEnd"
                                />
                                <div v-if="isSignatureEmpty" class="position-absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%); pointer-events: none; color: #8492a6; font-size: 20px; user-select: none;">
                                  여기에 서명을 그려주세요
                                </div>
                              </div>
                            </div>
                            <div class="mt-2">
                              <button class="btn btn-square btn-danger btn-sm" @click="signatureClear">서명 다시그리기</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mt-4">
                          <label class="text-muted mb-0 pt-2" >
                            개인정보 수집 및 이용 동의 
                          </label>
                          <div style="flex: 1;">
                            <div 
                              class="form-control font-weight-bold"
                              style="min-height: 130px; padding: 15px; background-color: #fff; border: 1px solid #dee2e6; overflow-y: auto;"
                              v-html="textData.policy1"
                            ></div>
                          </div>
                          <div class="custom-control custom-checkbox mt-4">
                            <input type="checkbox" ref="sign_up_form_info_agree1" v-model="infoAgree1Agree" class="custom-control-input" id="sign_up_form_info_agree1">
                            <label class="custom-control-label text-center" for="sign_up_form_info_agree1">
                              개인정보 수집 및 이용에 동의합니다.
                            </label>
                          </div>
                        </div>
                      </div>
                     
                      <div class="col-md-6">
                        <div class="form-group mt-4 ">
                          <label class="text-muted mb-0 pt-2" >
                            개인정보 제3자 제공에 대해 동의
                          </label>
                          <div style="flex: 1;">
                            <div 
                              class="form-control font-weight-bold"
                              style="min-height: 130px; padding: 15px; background-color: #fff; border: 1px solid #dee2e6; overflow-y: auto;"
                              v-html="textData.policy2"
                            ></div>
                          </div>
                          <div class="custom-control custom-checkbox mt-4">
                            <input type="checkbox" ref="sign_up_form_info_agree2" v-model="infoAgree2Agree" class="custom-control-input input-lg" id="sign_up_form_info_agree2">
                            <label class="custom-control-label text-center" for="sign_up_form_info_agree2">
                              개인정보 제3자 제공에 대해 동의합니다.
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--end row-->
                    <div class="row text-center">
                      <div v-if="infoAgree1Agree && infoAgree2Agree" class="col-sm-12">
                        <input
                          type="submit"
                          id="submit"
                          name="send"
                          @click="submitSignUpForm"
                          class="submitBnt btn btn-lg btn-primary"
                          value="신청서 보내기"
                        />
                      </div>
                      <div v-if="!infoAgree1Agree || !infoAgree2Agree" class="col-sm-12">
                        <input
                          type="submit"
                          id="submit"
                          name="send"
                          class="submitBnt btn btn-lg btn-white text-secondary border-secondary disabled"
                          value="신청서 보내기"
                        />
                        
                      </div>
                      <div v-if="!infoAgree1Agree || !infoAgree2Agree" class="col-sm-12">
                        <span class="badge badge-warning"><i class="mdi mdi-alert"></i> 개인정보 수집동의와 3자제공 동의에 체크해주세요!</span>
                      </div>
                      <div class="col-sm-12 mt-4 mb-2">
                        <p class="text-muted para-desc mx-auto mb-0 font-size-13">
                          대구여성인권센터를 후원해주셔서 감사합니다.<i class="mdi mdi-heart text-danger"></i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 폼 끝 -->

      </section>
  
    </Layout>
  </template>
  